// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(app-attributes-and-parameters) {
  height: calc(100vh - 288px);
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.content-area {
  margin-bottom: 1%;
  overflow-y: hidden;
  overflow-x: hidden;
}

.heading {
  height: 9%;
}

.content {
  padding-left: 5px;
  padding-right: 5px;
  overflow-y: auto;
  overflow-x: hidden;
}

.sidebar {
  mix-blend-mode: normal;
  background-color: rgba(234, 234, 234, 0.29);
  width: 200px;
  flex-basis: 200px;
  min-width: 200px;
}

.menu-item-text {
  color: #B2B2B2;
  font-weight: 600;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.083333px;
  height: 25px;
  padding-left: 10px;
}

.menu {
  margin-top: 5px;
}

.active-heading {
  color: var(--theme-active-color, #243391);
}

.primary:disabled {
  background: lightgray !important;
  background-color: lightgray !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
